import { Component, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { environment } from '../../environments/environment';
@Component({
  selector: 'app-birthdays',
  templateUrl: './birthdays.component.html',
  styleUrls: ['./birthdays.component.less']
})
export class BirthdaysComponent implements OnInit {
  isCollapsed = false;
  loading = false;
  employees:any=[];
  employeesTotal:number;
  getFullYear: number = new Date().getFullYear();
  getMonth: number = new Date().getMonth() + 1;
  getDate: number = new Date().getDate();
  imgBaseURL =  environment.apiUrl + '/static/';
  perPage = -1;
  page = 1;
  constructor(
    private userService:UserService,
  ) { }

  refresh(): void {
  }

  ngOnInit() {
    this.getBirthday();
  }


  getBirthday(){
    this.loading = true;
    this.userService.getBirthday(this.perPage, this.page).subscribe((res:any)=>{
      this.employees = res.data.data;
      this.employeesTotal = res.data.total;
      this.loading = false;
      console.log("this.employees", this.employees) 
    });
  }

}
